<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1p" id="p0021-01-0"><a id="page15"></a><a href="#/contents#fn_14" id="sn_14">DAY 14</a></p>
<p class="ct1"><a href="#/contents#fn_14">OUR COMPASSIONATE AND GRACIOUS GOD</a></p>
<p class="ext"><span><i>The L<span class="small">ORD</span> God made garments of skin for Adam and his wife and clothed them. And the L<span class="small">ORD</span> God said, “The man must not be allowed to take also from the tree of life and eat, and live forever.”</i></span></p>
<p class="ext1"><span><i>So the L<span class="small">ORD</span> God banished him from the Garden of Eden.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 3:21–23</span></p>
<p class="tx1" id="p0021-04-5"><span class="dcap">W</span>hen he placed the man in the garden, God established a rule. Adam and Eve broke that rule. The consequences would come—and with them, God’s compassion and grace.</p>
<p class="tx">First, God clothed Adam and Eve. He killed an animal he had created—its blood was shed—to cover the nakedness of the man and woman. Then, showing more grace, God sent Adam and Eve out of the garden, lest they eat from the tree of life and “live forever.” A fallen world, populated by sinners, is no place anyone would want to live forever!</p>
<p class="tx">Our disobedience, our sin has continued. But two thousand years ago more blood was shed. This time the blood of Jesus was spilled in order to cover—to pay the price for—our sins and to enable us to be in relationship with God now and forever.</p>
<p class="tx">Life outside the garden can make us long for the intimate fellowship with God that Adam and Eve knew in the garden.</p>
<p class="tx3">GOD’S GRACE TOWARD US SINNERS COST HIM HIS HOLY SON.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter17.vue?24941272